import { TRANSITION_END } from 'mlmi-library/utils/animation';

$.fn.Transition = function()
{
  var self = this;
  self.el = {
    slate: self.find('.transition__slate'),
    graphics: self.find('.transition__graphics'),
  };
  self.state = {
    content_loaded: false,
    transition_done: false,
  };
  self.layers = undefined;

  self.content_ready = function(layers)
  {
    self.layers = layers;
    self.state.content_loaded = true;
    self.maybe_end();
  };

  self.start = function(link)
  {
    /* Reset slate */
    self.state.content_loaded = false;
    self.state.transition_done = false;
    self.removeClass('reset').addClass('will-appear');
    self.el.graphics.empty();

    /* Load logo */
    self.el.slate.attr("class", "transition__slate bg-" + link.data("color"));
    // if (link.data("logo")){
    //   let image = $('<img>').on('load', function(e){
    //     self.el.graphics.append(e.target);
    //     self.el.graphics.off(TRANSITION_END).on(TRANSITION_END, function(){
    //       $(this).off(TRANSITION_END);
    //       self.state.transition_done = true;
    //       self.maybe_end();
    //     });
    //     self.addClass('appear');
    //   });
    //   image.attr('src', link.data('logo'));
    // } else {
      setTimeout(function(){
        self.off(TRANSITION_END).on(TRANSITION_END, function(){
          $(this).off(TRANSITION_END);
          self.state.transition_done = true;
          self.maybe_end();
        });
        self.addClass('appear');
      }, 60);
    // }
  };

  self.maybe_end = function()
  {
    if (self.state.content_loaded && self.state.transition_done){
      self.layers.displayChildContent();
      self.addClass('will-disappear');
      setTimeout(function(){
        self.off(TRANSITION_END).on(TRANSITION_END, function(){
          $(this).off(TRANSITION_END);
          setTimeout(function(){
            self.addClass('reset').removeClass('will-appear appear will-disappear disappear');
          }, 250);
        }).addClass('disappear');
      }, 60);
    }
  };

  return function(){
    return self;
  }();
};
